<mat-card class="costOutage-counties-calculated-widget-container">
  <div #exportContent>
    <div class="header">
      <div class="span">How Economic Cost of Outages Are Calculated</div>
      <button class="header-btn" data-html2canvas-ignore mat-icon-button (click)="export()">
        <vulcan-icon size="24px" icon="download"></vulcan-icon>
      </button>
    </div>
    <div class="content">
      <p>The direct economic impact of power outage to electric utility customers (residential and non-residential) is
        estimated through a county-level modeling framework developed by TASTI-GRID team, integrating multiple data
        sources
        and analytical methods. This approach builds on established methodologies (including the ICE 2.2 framework, ICE
        calculator tool is developed by Lawrence Berkeley National Laboratory) while extending them with updated data
        and
        enhanced regional granularity using 2018–2025 datasets.</p>
      <p>Key components of the analysis include:</p>
      <ul>
        <li>
          <span class="subtitle">Outage characteristics:</span>
          Duration, timing (e.g., seasons, time of day, day of the week), and geographic location of events.
        </li>
        <li>
          <span class="subtitle">Customer composition:</span>
          Residential and non-residential customer counts affected.
        </li>
        <li>
          <span class="subtitle">Energy usage and rate patterns:</span>
          Annual electricity consumption per customer, cost per kilowatt-hours.
        </li>
        <li>
          <span class="subtitle">Economic context:</span>
          Household income, regional GDP, and industry mix (e.g., healthcare, manufacturing, education, and retail).
        </li>
      </ul>
      <p>
        This integrated methodology enables a more comprehensive and localized estimation of outage impacts, supporting
        better planning, prioritization, and resilience strategies. All estimates are developed at the county level and
        focus on major events (15% or 30,000 electricity customer impacted).
      </p>
    </div>
  </div>
</mat-card>
